import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { dropTask } from 'ember-concurrency';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';

class SettingsPayoutPayeeVerificationController extends Controller {
  @service('state-managers/application') applicationStateManager;
  @service('commands/hyperwallet-user-commands') hyperwalletUserCommands;
  @service('commands/payout-account-commands') payoutAccountCommands;
  @service router;
  @service session;
  @service shData;
  @service store;

  @computed('model.hyperwalletUser','loadHyperwalletUser.isRunning')
  get isLoading() {
    return !this.model.hyperwalletUser && this.loadHyperwalletUser.isRunning;
  }

  @dropTask
  *loadHyperwalletUser() {
    try {
      const userId = this.session.currentUser.id;
      const response = yield this.hyperwalletUserCommands.getHyperwalletUser(userId);
      this.shData.pushResponseToStore(response);
      const hyperwalletUser = this.store.peekRecord('hyperwalletUser', response.data.id);
      this.set('model.hyperwalletUser', hyperwalletUser);
      return hyperwalletUser;
    } catch (error) {
      handleErrorResponseWithModal(this, error);
    }
  }

  @dropTask
  *getAuthToken() {
    const hyperwalletUser = yield this.loadHyperwalletUser.perform();
    return hyperwalletUser?.authToken ?? '';
  }

  @action
  handleSubmitSuccess() {
    this.payoutAccountCommands.syncPayoutAccounts(this.session.currentUser)
      .then((response) => {
        this.shData.pushResponseToStore(response);
        this.router.transitionTo('settings.payout');
        this.applicationStateManager.addToast('Verification submitted');
      });
  }
}

export default SettingsPayoutPayeeVerificationController;
